import api from "./api";

const UserTrackingAPI = {
    trackVisitor: (params) => api.post(`/public/tracking-users/visitor`, params),
    startSession: (params) => api.post(`/public/tracking-users/session/start`, params),
    endSession: (params) => api.post(`/public/tracking-users/session/end`, params),
    pageView: (params) => api.post(`/public/tracking-users/pageview`, params),
    getUserVisitorsPaged: (params, searchString) => api.get(`/admin/tracking-users/visitors/paged`, { params: { ...params, searchString } }),
};

export default UserTrackingAPI;
